"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUUID = exports.getFileIconBasedFromFileType = exports.getParams = exports.booleanize = exports.ApplicationWorkflowResumeActions = exports.ApplicationWorkflowPreferredCommunicationMethodActions = exports.ApplicationContactInfoActions = void 0;
var csod = require("player-core");
var ApplicationContactInfoActions = (function () {
    function ApplicationContactInfoActions(component) {
        this.component = component;
    }
    ApplicationContactInfoActions.prototype.firstNameChange = function (firstName) {
        var bool = booleanize(this.component.view.state.applyWithErrorMessage);
        this.component.view.state.applyWithErrorMessage = '';
        this.component.view.state.actionItem.firstName.value = firstName;
        this.component.view.state.actionItem.firstName.errorMessage = '';
        this.component.view.helpers.returnResultsToPage();
        if (bool)
            this.component.forceRender();
    };
    ApplicationContactInfoActions.prototype.lastNameChange = function (lastName) {
        var bool = booleanize(this.component.view.state.applyWithErrorMessage);
        this.component.view.state.applyWithErrorMessage = '';
        this.component.view.state.actionItem.lastName.value = lastName;
        this.component.view.state.actionItem.lastName.errorMessage = '';
        this.component.view.helpers.returnResultsToPage();
        if (bool)
            this.component.forceRender();
    };
    ApplicationContactInfoActions.prototype.emailChange = function (email) {
        var bool = booleanize(this.component.view.state.applyWithErrorMessage || this.component.view.state.actionItem.email.errorMessage);
        this.component.view.state.applyWithErrorMessage = '';
        this.component.view.state.actionItem.email.errorMessage = '';
        this.component.view.state.actionItem.email.value = email;
        this.component.view.helpers.returnResultsToPage();
        if (bool)
            this.component.forceRender();
    };
    return ApplicationContactInfoActions;
}());
exports.ApplicationContactInfoActions = ApplicationContactInfoActions;
var ApplicationWorkflowPreferredCommunicationMethodActions = (function () {
    function ApplicationWorkflowPreferredCommunicationMethodActions(component) {
        this.component = component;
    }
    ApplicationWorkflowPreferredCommunicationMethodActions.prototype.preferredCommunicationOptionsChanged = function (pmcValue) {
        var bool = booleanize(this.component.view.state.actionItem.preferredCommunicationOptions.errorMessage);
        this.component.view.state.actionItem.preferredCommunicationOptions.value = pmcValue;
        this.component.view.state.actionItem.preferredCommunicationOptions.errorMessage = '';
        this.component.view.helpers.returnResultsToPage();
        if (bool)
            this.component.forceRender();
    };
    return ApplicationWorkflowPreferredCommunicationMethodActions;
}());
exports.ApplicationWorkflowPreferredCommunicationMethodActions = ApplicationWorkflowPreferredCommunicationMethodActions;
var ApplicationWorkflowResumeActions = (function () {
    function ApplicationWorkflowResumeActions(component) {
        this.component = component;
        this.invalidDateErrorMessage = csod.locales.get('ATS.Player.ResponsiveApplication.ResumeAction.InvalidDateRangeError', 'Please enter a valid date in the format of mm/dd/yyyy.');
        this.invalidMonthAndYearOnlyErrorMessage = csod.locales.get('ATS.Player.ResponsiveApplication.ResumeAction.invalidMonthAndYearOnlyErrorMessage', 'Please enter a valid date in the format of mm/yyyy.');
    }
    ApplicationWorkflowResumeActions.prototype.resumeDataChanged = function (value, id) {
        var _a = id.split('_'), idStem = _a[0], sIndex = _a[1], eIndex = _a[2], vIndex = _a[3];
        this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].value1 = value;
        this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].errorMessage = '';
        this.component.view.helpers.returnResultsToPage();
    };
    ApplicationWorkflowResumeActions.prototype.contactDetailsChanged = function (value, id) {
        var _a = id.split('_'), idStem = _a[0], property = _a[1];
        this.component.view.state.actionItem.contactDetails[property].value = value;
        this.component.view.state.actionItem.contactDetails[property].errorMessage = '';
        this.component.view.helpers.returnResultsToPage();
    };
    ApplicationWorkflowResumeActions.prototype.contactDetailsCountryChanged = function (value) {
        var bool = booleanize(this.component.view.state.actionItem.contactDetails.country.errorMessage);
        this.component.view.state.actionItem.contactDetails.country.value = value;
        this.component.view.state.actionItem.contactDetails.country.errorMessage = '';
        this.component.view.helpers.returnResultsToPage();
        if (bool)
            this.component.forceRender();
    };
    ApplicationWorkflowResumeActions.prototype.addEntry = function (sectionId) {
        var sectionIndex = -1;
        this.component.view.state.actionItem.resumeStructure.sections.some(function (s, sIndex) {
            if (s.sectionId == sectionId) {
                sectionIndex = sIndex;
                return true;
            }
        });
        if (sectionIndex != -1) {
            var section = this.component.view.state.actionItem.resumeStructure.sections[sectionIndex];
            var entryIndex = section.entries.length;
            var newEntry = {};
            if (section.entries.length == 0) {
                newEntry.entryId = 0;
            }
            else {
                newEntry.entryId = Math.max.apply(null, section.entries.map(function (e) { return e.entryId; })) + 1;
            }
            newEntry.values = [];
            for (var _i = 0, _a = section.fields; _i < _a.length; _i++) {
                var field = _a[_i];
                var newValue = {};
                newValue.fieldId = field.fieldId;
                newValue.value1 = '';
                newValue.value2 = '';
                newValue.fieldData = this.component.view.helpers.populateFieldData(newValue, section.fields, sectionIndex, entryIndex, newEntry.values.length);
                if (newValue.fieldData.fieldTypeString === 'dropdown') {
                    newValue.value1 = this.component.view.helpers.getDropdownDefault(newValue.fieldData.options);
                }
                newEntry.values.push(newValue);
            }
            section.entries.push(newEntry);
            this.component.view.helpers.returnResultsToPage();
            this.component.forceRender();
        }
    };
    ApplicationWorkflowResumeActions.prototype.deleteEntry = function (sectionId, entry, entryIndex) {
        var _this = this;
        var currSections = this.component.view.state.actionItem.resumeStructure.sections;
        var currSection;
        var currPos;
        for (var i = 0; i < currSections.length; i++) {
            if (sectionId === currSections[i].sectionId) {
                currSection = currSections[i];
                currPos = i;
                break;
            }
        }
        currSection.entries.splice(entryIndex, 1);
        if (currSection.entries != undefined) {
            currSection.entries.map(function (entry, eIndex) {
                return entry.values.map(function (value, vIndex) {
                    return (value.fieldData['idTag'] = _this.component.view.helpers.generateIdTag(currPos, eIndex, vIndex));
                });
            });
        }
        this.component.view.state.actionItem.resumeStructure.sections[currPos] = currSection;
        this.component.view.helpers.returnResultsToPage();
        this.component.forceRender();
    };
    ApplicationWorkflowResumeActions.prototype.changeDate = function (date, value, isValid, id) {
        var _a = id.split('_'), idStem = _a[0], sIndex = _a[1], eIndex = _a[2], vIndex = _a[3];
        var hasError = !isValid || booleanize(this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].errorMessage);
        var displayFullDate = this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].fieldData["displayFullDate"];
        if (isValid && date) {
            this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].value1 = date;
            this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].errorMessage = '';
        }
        else {
            this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].value1 = '';
            this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].errorMessage = isValid ? '' : (displayFullDate ? this.invalidDateErrorMessage : this.invalidMonthAndYearOnlyErrorMessage);
        }
        this.component.view.helpers.returnResultsToPage();
        if (hasError)
            this.component.forceRender();
    };
    ApplicationWorkflowResumeActions.prototype.changeDaterange = function (date, value, isValid, id) {
        var _a = id.split('_'), idStem = _a[0], sIndex = _a[1], eIndex = _a[2], vIndex = _a[3], vvIndex = _a[4];
        var hasError = !isValid
            || booleanize(this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].errorMessage)
            || booleanize(this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].startDateErrorMessage)
            || booleanize(this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].endDateErrorMessage);
        var displayFullDate = this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].fieldData["displayFullDate"];
        if (isValid && date) {
            if (vvIndex === '1') {
                this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].value1 = date;
                this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].startDateErrorMessage = '';
            }
            else {
                this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].value2 = date;
                this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].endDateErrorMessage = '';
            }
            this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].errorMessage = '';
        }
        else {
            if (vvIndex === '1') {
                this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].value1 = '';
                this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].startDateErrorMessage = isValid ? '' : (displayFullDate ? this.invalidDateErrorMessage : this.invalidMonthAndYearOnlyErrorMessage);
            }
            else {
                this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].value2 = '';
                this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].endDateErrorMessage = isValid ? '' : (displayFullDate ? this.invalidDateErrorMessage : this.invalidMonthAndYearOnlyErrorMessage);
            }
            this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].errorMessage = isValid ? '' : (displayFullDate ? this.invalidDateErrorMessage : this.invalidMonthAndYearOnlyErrorMessage);
        }
        this.component.view.helpers.returnResultsToPage();
        if (hasError)
            this.component.forceRender();
    };
    ApplicationWorkflowResumeActions.prototype.resumeDataChangeNoId = function (value, field) {
        var id = field.fieldData.idTag;
        var _a = id.split('_'), idStem = _a[0], sIndex = _a[1], eIndex = _a[2], vIndex = _a[3];
        var bool = booleanize(this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].errorMessage);
        this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].value1 = value;
        this.component.view.state.actionItem.resumeStructure.sections[sIndex].entries[eIndex].values[vIndex].errorMessage = '';
        this.component.view.helpers.returnResultsToPage();
        if (bool)
            this.component.forceRender();
    };
    ApplicationWorkflowResumeActions.prototype.coverLetterDataChanged = function () {
        this.component.view.helpers.returnResultsToPage();
    };
    ApplicationWorkflowResumeActions.prototype.initializeResumeViewer = function () {
        var _a = this.component.view.state.actionItem, resumeFileUploadToken = _a.resumeFileUploadToken, resumeSourceType = _a.resumeSourceType;
        if ((resumeSourceType == 2 || resumeSourceType == 7) && resumeFileUploadToken.fileUrl) {
            resumeFileUploadToken.title = this.component.props.profileAddedText;
            resumeFileUploadToken.fileSize = 'LinkedIn';
            resumeFileUploadToken.fileIcon = '';
            resumeFileUploadToken.brandIcon = 'LinkedIn';
            resumeFileUploadToken.fileIconBackgroundColor = '';
        }
        else if (resumeSourceType == 4) {
            if (!resumeFileUploadToken.fileIcon && resumeFileUploadToken.fileUrl) {
                var fileIcon = 'Generic';
                var urlParts = resumeFileUploadToken.fileUrl.split('?');
                if (urlParts.length > 1) {
                    var queryString = urlParts[1];
                    var params = getParams(queryString);
                    var fileName = params['FileName'];
                    fileIcon = getFileIconBasedFromFileType(fileName);
                }
                resumeFileUploadToken.fileIcon = fileIcon;
                resumeFileUploadToken.brandIcon = '';
            }
        }
        else if (resumeSourceType == 6 && resumeFileUploadToken.fileUrl) {
            resumeFileUploadToken.title = this.component.props.profileAddedText;
            resumeFileUploadToken.fileSize = 'Seek';
            resumeFileUploadToken.fileIcon = '';
            resumeFileUploadToken.brandIcon = 'Seek';
            resumeFileUploadToken.fileIconBackgroundColor = '';
            resumeFileUploadToken.fileUrl = '';
        }
    };
    ApplicationWorkflowResumeActions.prototype.onAdditionalAttachmentUploadSuccess = function (data, fileUploadId) {
        var _a = fileUploadId.split('_'), section = _a[0], type = _a[1], index = _a[2], attachmentId = _a[3], fileIdx = _a[4];
        var additionalAttachment = this.component.view.state.actionItem.additionalAttachments[index];
        additionalAttachment.errorMessage = '';
        if (data.files[0].errors !== null && data.files[0].errors.length > 0) {
            additionalAttachment.errorMessage = data.files[0].errors[0].Value;
        }
        else {
            var baseUploaderUrl = csod.context.applicationBase + "uploader/";
            additionalAttachment.fileUploads[fileIdx].token.title = data.files[0].name;
            additionalAttachment.fileUploads[fileIdx].token.fileSize = Math.floor(data.files[0].length / 1000) + ' KB';
            additionalAttachment.fileUploads[fileIdx].token.fileUrl = '';
            additionalAttachment.fileUploads[fileIdx].token.deleteUrl = baseUploaderUrl + data.files[0].delete_url;
            additionalAttachment.fileUploads[fileIdx].token.fileIcon = getFileIconBasedFromFileType(data.files[0].name);
            additionalAttachment.fileUploads[fileIdx].token.showUpload = false;
            this.component.view.helpers.returnResultsToPage();
        }
    };
    ApplicationWorkflowResumeActions.prototype.onAdditionalAttachmentUploadError = function (error, message, fileUploadId) {
        var _a = fileUploadId.split('_'), section = _a[0], type = _a[1], index = _a[2], attachmentId = _a[3];
        var additionalAttachment = this.component.view.state.actionItem.additionalAttachments[index];
        if (error != null) {
            console.log('onFileUploadError:', error);
            message = this.component.props.fileUploadErrorMessage;
        }
        additionalAttachment.errorMessage = message;
    };
    ApplicationWorkflowResumeActions.prototype.onAdditionalAttachmentDelete = function (fileViewerId) {
        var _this = this;
        var _a = fileViewerId.split('_'), section = _a[0], type = _a[1], index = _a[2], attachmentId = _a[3], fileIdx = _a[4];
        var additionalAttachment = this.component.view.state.actionItem.additionalAttachments[index];
        var fileUpload = additionalAttachment.fileUploads[fileIdx];
        if (fileUpload.token.deleteUrl) {
            csod.service
                .post(fileUpload.token.deleteUrl)
                .catch(function (error) {
                fileUpload.token.value = createUUID();
            })
                .then(function (data) {
                additionalAttachment.deleteFileUpload(fileIdx);
                _this.component.view.helpers.returnResultsToPage();
                csod.engine.commit();
            });
        }
        else {
            additionalAttachment.deleteFileUpload(fileIdx);
            this.component.view.helpers.returnResultsToPage();
        }
    };
    ApplicationWorkflowResumeActions.prototype.onAdditionalAttachmentCreate = function (attachment) {
        attachment.addNewFileUpload();
    };
    return ApplicationWorkflowResumeActions;
}());
exports.ApplicationWorkflowResumeActions = ApplicationWorkflowResumeActions;
function booleanize(x) {
    return x ? true : false;
}
exports.booleanize = booleanize;
function getParams(query) {
    if (!query) {
        return {};
    }
    return (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
        var _a = param.split('='), key = _a[0], value = _a[1];
        params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
        return params;
    }, {});
}
exports.getParams = getParams;
function getFileIconBasedFromFileType(fileName) {
    if (!fileName) {
        return 'Generic';
    }
    var fileNameParts = fileName.split('.');
    var fileType = 'txt';
    if (fileNameParts.length > 1) {
        fileType = fileNameParts[fileNameParts.length - 1];
    }
    var fileIcon;
    switch (fileType.toLowerCase()) {
        case 'txt':
            fileIcon = 'Generic';
            break;
        case 'pdf':
            fileIcon = 'Pdf';
            break;
        case 'doc':
        case 'docx':
            fileIcon = 'Text';
            break;
        case 'bmp':
        case 'gif':
        case 'jpg':
        case 'jpeg':
        case 'png':
            fileIcon = 'Image';
            break;
        default:
            fileIcon = 'Generic';
            break;
    }
    return fileIcon;
}
exports.getFileIconBasedFromFileType = getFileIconBasedFromFileType;
function createUUID() {
    var s = [];
    var hexDigits = '0123456789abcdef';
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4';
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = '-';
    var uuid = s.join('');
    return uuid;
}
exports.createUUID = createUUID;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent2/work/8b1685a0cde68c49/src/actions/ApplicationActions.ts
// module id = 22
// module chunks = 0 2